import { API_BASE_URL, BACKEND_URL_ORIGIN, BACKEND_DOMAIN, DNEVNIK2_URL, IS_JOURNAL_MODE, version } from "../assets/const";
import { buildDefaultHeaders } from "./helper";
import { api } from "../App";
import moment from 'moment'
import { AUTH_COMPLETED, AUTH_ERROR, SET_AUTH_LOADING, SET_AUTH_USER_INFO, SET_USER_PERMISSIONS, SIGNED_OUT } from "./types";
import { createNotification } from "../components/Notifications/Notifications";

const TOKEN_UPDATING_INTERVAL = 190;

const getTimeToExpireToken = (getState) => {
  const { valid_until } = getState().auth;
  return moment(valid_until).diff(moment.utc()) / 1000 / 60;
};

export const checkAndUpdateToken = () => async (dispatch, getState) => {
  const timeToExpire = getTimeToExpireToken(getState);
  if (timeToExpire < TOKEN_UPDATING_INTERVAL) {
    try {
      const response = await fetch(
        IS_JOURNAL_MODE ? `${DNEVNIK2_URL}/proxy/api/token` : `${API_BASE_URL}/token`,
        buildDefaultHeaders(getState)
      );
      if (response.ok) {
        const result = await response.json();
        if (result.error && result.error.code === 401) {
          dispatch(signOut())
        } else {
          dispatch({ type: AUTH_COMPLETED, user: result });
        }
      } else {
        dispatch(signOut())
      }
    } catch (ERR) {
      dispatch(signOut())
    }
  }

};

export const auth = (values) => async (dispatch, getState) => {
  dispatch({ type: SET_AUTH_LOADING, payload: true });
  try {
    const { username, password } = values;
    const { base } = getState().auth;
    const tok = `${username.trim()}:${password.trim()}`;
    const hash = window.btoa(unescape(encodeURIComponent(tok)));
    const Authorization = `Basic ${hash}`;

    const response = await fetch(IS_JOURNAL_MODE ? `${DNEVNIK2_URL}/proxy/api/token` : `${API_BASE_URL}/token`, {
      headers: {
        Authorization,
        "Access-Control-Allow-Origin": "*",
        ...(IS_JOURNAL_MODE && base && { "X-School-Id": base }),
      },
    });

    if (response.ok) {
      const result = await response.json();
      dispatch({ type: AUTH_COMPLETED, user: result });
      await dispatch(getUserPermissions())
    } else {
      const result = await response.json();
      dispatch({ type: AUTH_ERROR, payload: result.error.key || result.error.message });
      // const errorText = response.status === 401 ? "Неверное имя пользователя или пароль" : "Ошибка авторизации"
      createNotification('error', result.error.message)
    }
  } catch (ERROR) {
    createNotification("error", "Сбой авторизации");
    console.log(ERROR);
  } finally {
    dispatch({ type: SET_AUTH_LOADING, payload: false });
  }
};

export const signOut = () => async (dispatch) => {
  dispatch({ type: SIGNED_OUT });
};

export const getUserPermissions = () => async (dispatch, getState) => {
  try {
    const {data} = await api.get(`/access_control`);
    dispatch({ type: SET_USER_PERMISSIONS, payload: data });
  } catch (error) {
  }
};
